import styled from "@emotion/styled"
import { Button } from "@mui/material"
import Link from "next/link"
import { Container, Desktop, Mobile, NewText, PdfIcon } from "ui"
import { sharedColors } from "ui/theme/colors"
import { extractProperty, getUmbracoPDFUrl } from "utils"
import { convertISODateString } from "utils/utils"
import { StyledContainer } from "./InvestmentBlock"

const StyledCard = styled.div`
  display: flex;
  padding: 24px;
  justify-content: center;
  gap: 24px;
  border-radius: 16px;
  background: white;
  width: 100%;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
`
const TextBox = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`
const MobileFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

function SingleFileBlock({ data }: { data: any }) {
  const fileName = extractProperty(data, "fileName") as string | undefined
  const date = extractProperty(data, "date") as string | undefined
  const button = extractProperty(data, "button") as {
    name: string
    url: string
  }[]
  const buttonName = button?.[0]?.name as string | undefined
  const buttonUrl = button?.[0]?.url as string | undefined
  return (
    <StyledContainer>
      <Container>
        <Desktop>
          <StyledCard>
            <PdfIcon height={"40px"} width={"40px"} />
            <TextBox>
              <NewText
                component={"p"}
                desktopFontSize={18}
                desktopFontWeight={600}
                color={sharedColors.black}
              >
                {fileName}
              </NewText>
              <NewText component={"span"} desktopFontSize={14} color="#6F6F6F">
                {convertISODateString(date)}
              </NewText>
            </TextBox>
            <Link
              target={buttonUrl?.includes(".") ? "_blank" : "_self"}
              href={getUmbracoPDFUrl(buttonUrl) || ""}
            >
              <Button variant="outlined" size="large" style={{ fontSize: 20 }}>
                {buttonName}
              </Button>
            </Link>
          </StyledCard>
        </Desktop>
        <Mobile>
          <MobileContainer>
            <MobileFlex>
              <PdfIcon height={"40px"} width={"40px"} />
              <NewText
                component={"p"}
                desktopFontSize={14}
                desktopFontWeight={600}
                color={sharedColors.black}
              >
                {fileName}
              </NewText>
            </MobileFlex>
            <MobileFlex>
              <NewText component={"span"} desktopFontSize={14} color="#6F6F6F">
                {convertISODateString(date)}
              </NewText>
              <Link
                target={buttonUrl?.includes(".") ? "_blank" : "_self"}
                href={getUmbracoPDFUrl(buttonUrl) || ""}
              >
                <Button variant="outlined" size="large" style={{ fontSize: 20 }}>
                  {buttonName}
                </Button>
              </Link>
            </MobileFlex>
          </MobileContainer>
        </Mobile>
      </Container>
    </StyledContainer>
  )
}

export default SingleFileBlock
